/**
 * Main Application File
 *
 * Use for bootstrapping large application
 * or just fill it with JS on small projects
 *
 */

import 'babel-polyfill';

import './base/plugins';
import './layouts/header';
import './layouts/lab';
import './layouts/realizzazioni';
// import './layouts/form';
import './components/scrollElements';
import './components/imagesSlider';



/** WEBPACK FOOTER **
 ** ./app.js
 **/